import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { nextLoanRepaymentApi } from '../../apis/metrics';
import { INextLoanRepayment } from '../../interfaces/metrics';

export const useFetchNextLoanRepayment = () => {

  const [nextLoanRepayment, setNextLoanRepayment] = useState<INextLoanRepayment[]>([]);
  const [error, setError] = useState<null|Error>(null);
  const [fetching, setFetching] = useState(false);

  const fetchNextLoanRepayment = useCallback(async () => {
    try {
      setError(null);
      setFetching(true);
      const response = await nextLoanRepaymentApi();
      const nextLoanRepayment: INextLoanRepayment[] = response.data;
      setFetching(false);
      setNextLoanRepayment(nextLoanRepayment);
    } catch (error) {
      setFetching(false);
      const axiosError = error as AxiosError;
      setError(axiosError);
    }
  }, [])

  useEffect(() => {
    if (nextLoanRepayment.length < 1) {
    fetchNextLoanRepayment();
    }
  }, [fetchNextLoanRepayment, nextLoanRepayment.length]);


  return { nextLoanRepayment, error, fetching, fetchNextLoanRepayment };
};
